import React from "react";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "#0A0A0A" }}>
      <div className="flex-1">
        <div className="border-b" style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}>
          <div className="max-w-4xl mx-auto px-6 py-4">
            <a href="/" className="text-xl font-semibold" style={{ color: "#3D6B4A" }}>
              NutriNori
            </a>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-16">
          <h1 className="text-4xl font-bold mb-8" style={{ color: "#FFFFFF" }}>
            Politique de confidentialité
          </h1>
          
          <div className="space-y-6 text-base leading-relaxed" style={{ color: "rgba(255, 255, 255, 0.7)" }}>
            <p>
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                1. Introduction
              </h2>
              <p>
                NutriNori s'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                2. Données collectées
              </h2>
              <p>
                Nous collectons les informations que vous nous fournissez directement, notamment :
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Informations de compte (email, nom)</li>
                <li>Données d'utilisation de l'application</li>
                <li>Photos de repas (si vous utilisez la fonction scan)</li>
                <li>Préférences nutritionnelles</li>
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                3. Utilisation des données
              </h2>
              <p>
                Vos données sont utilisées pour :
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Fournir et améliorer nos services</li>
                <li>Analyser vos repas et fournir des recommandations nutritionnelles</li>
                <li>Personnaliser votre expérience</li>
                <li>Communiquer avec vous concernant votre compte</li>
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                4. Protection des données
              </h2>
              <p>
                Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès, modification, divulgation ou destruction non autorisés.
              </p>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                5. Vos droits
              </h2>
              <p>
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit à la portabilité</li>
                <li>Droit d'opposition au traitement</li>
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-2xl font-semibold mb-4" style={{ color: "#FFFFFF" }}>
                6. Contact
              </h2>
              <p>
                Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous à :
              </p>
              <p className="mt-2">
                <a href="mailto:support@nutrinori.com" style={{ color: "#3D6B4A" }} className="hover:underline">
                  support@nutrinori.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer theme="dark" />
    </div>
  );
};

export default Privacy;
